import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { VisitorReasonRequest } from "./VisitorReasonRequest";

@Injectable()
export class DataService_ReasonMaintenance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	VisitorReasonPreferenceInfoSelect() {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorReasonPreferenceInfoSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorReasonTableSelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorReasonTableSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorReasonInsert(parms: VisitorReasonRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorReasonInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorReasonUpdate(parms: VisitorReasonRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorReasonUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorReasonToggle(VisitorReasonID, Active) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorReasonToggle?VisitorReasonID=" + VisitorReasonID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorReasonDelete(VisitorReasonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorReasonDelete?VisitorReasonID=" + VisitorReasonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorReasonInUse(parms: VisitorReasonRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorReasonInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
